// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fade-enter-active[data-v-083f36e8],.fade-leave-active[data-v-083f36e8]{-webkit-transition:opacity .3s;transition:opacity .3s}.fade-enter[data-v-083f36e8],.fade-leave-to[data-v-083f36e8]{opacity:0}#ccp[data-v-083f36e8],#parent[data-v-083f36e8]{height:calc(100% - 56px)}#ccp[data-v-083f36e8]{width:26%;position:absolute;display:none}", ""]);
// Exports
module.exports = exports;
